import React from 'react';

import { StaffingRequestApplicationState } from '@common/graphql';
import { MissionControlStaffingTableCandidatesBase } from './_mission-control-staffing-table-candidates-base';

const IN_SCREENING_STATES: StaffingRequestApplicationState[] = [
  'submitted',
  'submittal_packet_change_requested',
];

export function MissionControlStaffingTableCandidatesInScreening() {
  return (
    <MissionControlStaffingTableCandidatesBase
      tableKind="InScreening"
      defaultStateFilters={IN_SCREENING_STATES}
    />
  );
}
